import { ApiUserRole } from '@/enum/ApiUserRole'
import { TemplateMail } from '@/enum/TemplateMail'
import { AloAddress, getDefaultAloAddress } from './AloAddress'
import { AloBase, getDefaultAloBase } from './AloBase'


export interface AloUser extends AloBase {
            
    actId: number|null
    famId: number|null
    usrCivilite: number|null
    usrDatlog: string
    usrDatbirth: string
    usrNom: string
    usrPrenom: string
    usrTel: string    
    usrEmail: string
    usrNoteInterne: string        
    actDisabled: boolean
    roles: Array<ApiUserRole>
    address: AloAddress
    famName: string
    famActId: number
    mtpId: TemplateMail|null
    membres: Array<AloUser>
}

export const getDefaultAloUser = (role:ApiUserRole = ApiUserRole.Client):AloUser => {
    return {  
        ...getDefaultAloBase(),        
        actId : null,
        famId: null,
        usrCivilite:null,
        usrDatlog:"",
        usrDatbirth:"",
        usrNom:"",
        usrPrenom:"",        
        usrTel:"",
        usrEmail:"",
        usrNoteInterne:"",                
        actDisabled:true,
        roles:[],
        address:getDefaultAloAddress(),
        famName:"",
        famActId:0,
        mtpId:null,
        membres:[]
    }
}


export const cleanAloUser = (user:AloUser) => {
    if(!user) return    
    if(!user.id) delete user.id
    if(!user.actId) delete user.actId    
    if(!user.famId) delete user.famId     
    if(!user.usrCivilite) delete user.usrCivilite   
    if(!user.mtpId) delete user.mtpId    
}

